import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'vi-card',
  templateUrl: 'card.component.html',
  styleUrls: ['card.component.scss'],
  standalone: true,
  imports: [CommonModule, MatCardModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViCardComponent {
  @Input() title: Boolean = true;
  @Input() footer: Boolean = true;
  @Input() dialog: Boolean = false;
  @Input() autoHeight: Boolean = false;
}
